import { Security2FA1Widget, TrustedDevices1Widget, TrustedDevices2Widget } from './components/DataSecurityWidget';

const DATASECURITY_WEIGHT = 20;
const TWOFA_WEIGHT = 5;

export const useDashboardDataSecurityWidgets = () => [
    {
        component: <TrustedDevices1Widget />,
        weight: DATASECURITY_WEIGHT,
    },
    {
        component: <TrustedDevices2Widget />,
        weight: DATASECURITY_WEIGHT,
    },
    {
        component: <Security2FA1Widget />,
        weight: TWOFA_WEIGHT,
    },
];
